import { ICourse } from '@interfaces/ICourse';
import { ICourseFormErrors } from '@interfaces/ICourseFormErrors';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';

export enum ECoursesChangesActions {
  SendCreateCourseRequest = '[Courses] Send Create Course Request',
  SendCreateCourseSuccess = '[Courses] Send Create Course Success',
  SendCreateCourseFailure = '[Courses] Send Create Course Failure',
  ClearCreateCourseErrors = '[Courses] Clear Create Course Errors',

  SendUpdateCourseRequest = '[Courses] Send Update Course Request',
  SendUpdateCourseSuccess = '[Courses] Send Update Course Success',
  SendUpdateCourseFailure = '[Courses] Send Update Course Failure',
  ClearUpdateCourseErrors = '[Courses] Clear Update Course Errors',

  DeleteCourseRequest = '[Courses] Delete Course Request',
  DeleteCourseSuccess = '[Courses] Delete Course Success',
  DeleteCourseFailure = '[Courses] Delete Course Failure',
  ClearDeleteCourseErrors = '[Courses] Clear Delete Course Errors',

  SendDeactivateCourseRequest = '[Courses] Send Deactivate Course Request',
  SendDeactivateCourseSuccess = '[Courses] Send Deactivate Course Success',
  SendDeactivateCourseFailure = '[Courses] Send Deactivate Course Failure',
  ClearDeactivateCourseErrors = '[Courses] Clear Deactivate Course Errors',

  ActivateCourseRequest = '[Courses] Activate Course Request',
  ActivateCourseSuccess = '[Courses] Activate Course Success',
  ActivateCourseFailure = '[Courses] Activate Course Failure',
  ClearActivateCourseErrors = '[Courses] Clear Activate Course Errors',
}

export class SendCreateCourseRequest implements Action {
  public readonly type = ECoursesChangesActions.SendCreateCourseRequest;

  constructor(public data: ICourse) {}
}

export class SendCreateCourseSuccess implements Action {
  public readonly type = ECoursesChangesActions.SendCreateCourseSuccess;
}

export class SendCreateCourseFailure implements Action {
  public readonly type = ECoursesChangesActions.SendCreateCourseFailure;

  constructor(public errors: ICourseFormErrors) {}
}

export class ClearCreateCourseErrors implements Action {
  public readonly type = ECoursesChangesActions.ClearCreateCourseErrors;
}

export class SendUpdateCourseRequest implements Action {
  public readonly type = ECoursesChangesActions.SendUpdateCourseRequest;

  constructor(public id: number, public data: ICourse) {}
}

export class SendUpdateCourseSuccess implements Action {
  public readonly type = ECoursesChangesActions.SendUpdateCourseSuccess;
}

export class SendUpdateCourseFailure implements Action {
  public readonly type = ECoursesChangesActions.SendUpdateCourseFailure;

  constructor(public errors: ICourseFormErrors) {}
}

export class ClearUpdateCourseErrors implements Action {
  public readonly type = ECoursesChangesActions.ClearUpdateCourseErrors;
}

export class DeleteCourseRequest implements Action {
  public readonly type = ECoursesChangesActions.DeleteCourseRequest;

  constructor(public courseId: number, public title: string) {}
}

export class DeleteCourseSuccess implements Action {
  public readonly type = ECoursesChangesActions.DeleteCourseSuccess;
}

export class DeleteCourseFailure implements Action {
  public readonly type = ECoursesChangesActions.DeleteCourseFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteCourseErrors implements Action {
  public readonly type = ECoursesChangesActions.ClearDeleteCourseErrors;
}

export class SendDeactivateCourseRequest implements Action {
  public readonly type = ECoursesChangesActions.SendDeactivateCourseRequest;

  constructor(public id: number) {}
}

export class SendDeactivateCourseSuccess implements Action {
  public readonly type = ECoursesChangesActions.SendDeactivateCourseSuccess;
}

export class SendDeactivateCourseFailure implements Action {
  public readonly type = ECoursesChangesActions.SendDeactivateCourseFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeactivateCourseErrors implements Action {
  public readonly type = ECoursesChangesActions.ClearDeactivateCourseErrors;
}

export class ActivateCourseRequest implements Action {
  public readonly type = ECoursesChangesActions.ActivateCourseRequest;

  constructor(public id: number) {}
}

export class ActivateCourseSuccess implements Action {
  public readonly type = ECoursesChangesActions.ActivateCourseSuccess;
}

export class ActivateCourseFailure implements Action {
  public readonly type = ECoursesChangesActions.ActivateCourseFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearActivateCourseErrors implements Action {
  public readonly type = ECoursesChangesActions.ClearActivateCourseErrors;
}

export type CoursesChangesActions =
  | SendCreateCourseRequest
  | SendCreateCourseSuccess
  | SendCreateCourseFailure
  | ClearCreateCourseErrors
  | SendUpdateCourseRequest
  | SendUpdateCourseSuccess
  | SendUpdateCourseFailure
  | ClearUpdateCourseErrors
  | SendDeactivateCourseRequest
  | SendDeactivateCourseSuccess
  | SendDeactivateCourseFailure
  | ClearDeactivateCourseErrors
  | ActivateCourseRequest
  | ActivateCourseSuccess
  | ActivateCourseFailure
  | ClearActivateCourseErrors
  | DeleteCourseRequest
  | DeleteCourseSuccess
  | DeleteCourseFailure
  | ClearDeleteCourseErrors;
